import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { ChevronDown, ChevronUp } from 'react-feather';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../icon';
import './accordion.scss';
import Toggle, { ToggleSizes } from '../toggle/toggle';

const AccordionTypes = {
  GRAY: 'accordion-gray',
  ERROR: 'accordion-error',
  WARNING: 'accordion-warning',
  SUCCESS: 'accordion-success',
};

const Accordion = ({
  children, label, description, className, expanded, onExpandStateChange,
  withToggle, isExpandable, toggleSize,
  renderIcon, bordered, type, renderHeader,
}) => {
  const [open, setOpen] = useState(expanded);

  const toggleAccordion = () => {
    if (!isExpandable) {
      return;
    }
    setOpen((prevState) => !prevState);
  };

  useEffect(() => {
    onExpandStateChange(open);
  }, [open]);

  useEffect(() => {
    setOpen(isExpandable === false ? false : expanded ?? isExpandable);
  }, [isExpandable, expanded]);

  return (
    <div className={clsx('accordion-cont', className)}>
      <div onClick={toggleAccordion} className={clsx('accordion-header-icon', className, bordered && type, { 'show-separator': !bordered })}>
        <div className="accordion-label-desc-icon">
          {renderIcon && (
          <div className="accordion-icon">
            {renderIcon({ size: IconSizes.MEDIUM, type: renderIcon })}
          </div>
          )}
          { renderHeader
            ? renderHeader()
            : (
              <div className="accordion-label-desc">
                <span className="accordion-label">{label}</span>
                <span className="accordion-desc">{description}</span>
              </div>
            )}
        </div>
        <div className="toggle-cont-accordion-icon-wrapper">
          {withToggle && (
          <Toggle
            checked={open}
            size={toggleSize}
          />
          )}
          <Icon
            className="accordion-chevron"
            icon={open ? ChevronUp : ChevronDown}
          />
        </div>
      </div>
      {open ? children : null}
    </div>

  );
};
Accordion.defaultProps = {
  description: null,
  label: '',
  className: null,
  expanded: false,
  withToggle: false,
  isExpandable: true,
  onExpandStateChange: () => {},
  toggleSize: ToggleSizes.MEDIUM,
  renderIcon: null,
  bordered: false,
  type: AccordionTypes.GRAY,
  renderHeader: null,
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  expanded: PropTypes.bool,
  withToggle: PropTypes.bool,
  isExpandable: PropTypes.bool,
  toggleSize: PropTypes.oneOf([ToggleSizes.SMALL, ToggleSizes.MEDIUM]),
  onExpandStateChange: PropTypes.func,
  renderIcon: PropTypes.func,
  bordered: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(AccordionTypes)),
  renderHeader: PropTypes.func,
};

export {
  Accordion as default,
  AccordionTypes,
};

// TODO: Add storybook entry for accordion
